import { formatValueToPercent } from '../formatters';

export const getConfigByDirection =
  direction =>
  (items = []) => ({
    ...items.reduce(
      ({ lines, marks }, item, index, { length }) => {
        let offset, mark;

        if (typeof item === 'function') {
          const compute = item();

          if (compute.mark === void 0 || compute.offset === void 0) {
            throw new Error('Provide valid mark and offset for each item, or use primitive value');
          }

          mark = compute.mark;
          offset = compute.offset;
        } else {
          mark = item;
          offset = index ? (index / (length - 1)) * 100 : 0;
        }

        return {
          lines: [
            ...lines,
            {
              x1: direction === 'vertical' ? offset : 0,
              x2: direction === 'vertical' ? offset : 100,
              y1: direction === 'horizontal' ? offset : 0,
              y2: direction === 'horizontal' ? offset : 100
            }
          ],
          marks: [
            ...marks,
            {
              mark,
              left: direction === 'vertical' ? formatValueToPercent(offset, 4) : void 0,
              top: direction === 'horizontal' ? formatValueToPercent(offset, 4) : void 0
            }
          ]
        };
      },
      {
        lines: [],
        marks: []
      }
    )
  });
